// src/pages/Download.jsx

import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Tabs,
  Tab,
  Grid,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import QRCodeDisplay from '../components/QRCodeDisplay';
import TouchableImage from '../components/TouchableImage';
import app_store from '../assets/app_store.svg';
import play_en from '../assets/play_en.png';

function Download() {
  const [platform, setPlatform] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (_, newValue) => {
    setPlatform(newValue);
  };

  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" align="center" gutterBottom>
          Download MindMapper AI
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 4 }}>
          Get the app on your favorite platform and start exploring your dreams and mindfulness.
        </Typography>

        <Tabs
          value={platform}
          onChange={handleChange}
          centered={!isMobile}
          variant={isMobile ? 'fullWidth' : 'standard'}
        >
          <Tab label="iOS" />
          <Tab label="Android" />
        </Tabs>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          {platform === 0 && (
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <TouchableImage
                  image_path={app_store}
                  image_alt="App Store"
                  onClick={() => window.open('https://apps.apple.com/your-app-link')}
                />
              </Grid>
              <Grid item>
                <QRCodeDisplay value="https://apps.apple.com/your-app-link" />
              </Grid>
            </Grid>
          )}
          {platform === 1 && (
            <Grid container spacing={2} justifyContent="center">
              <Grid item>
                <TouchableImage
                  image_path={play_en}
                  image_alt="Play Store"
                  onClick={() =>
                    window.open('https://play.google.com/store/apps/details?id=com.mindmapper.mindmapperai')
                  }
                />
              </Grid>
              <Grid item>
                <QRCodeDisplay value="https://play.google.com/store/apps/details?id=com.mindmapper.mindmapperai" />
              </Grid>
            </Grid>
          )}
        </Box>
      </Container>
    </Box>
  );
}

export default Download;
